export const navDiscountsMenu = [
  [
    {
      key: 'discounts:1',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/31/0?cName=Automotive&prevPage=All%20Deals',
      label: 'Automotive',
    },
    {
      key: 'discounts:2',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/32/0?cName=Entertainment&prevPage=All%20Deals',
      label: 'Entertainment',
    },
    {
      key: 'discounts:3',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/271/0?cName=Gift%20Cards&prevPage=All%20Deals',
      label: 'Gift Cards',
    },
    {
      key: 'discounts:4',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/34/0?cName=Health%20%26%20Services&prevPage=All%20Deals',
      label: 'Health & Services',
    },
    {
      key: 'discounts:5',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/33/0?cName=Home,%20Office%20%26%20Finance&prevPage=All%20Deals',
      label: 'Home, Office & Finance',
    },
    {
      key: 'discounts:6',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/35/0?cName=Restaurants&prevPage=All%20Deals',
      label: 'Restaurants',
    },
    {
      key: 'discounts:7',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/36/0?cName=Shopping&prevPage=All%20Deals',
      label: 'Shopping',
    },
    {
      key: 'discounts:8',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/246/101618?club=111&cName=Road%20Trips&prevPage=All%20Deals',
      label: 'Travel',
    },
  ],
  [
    {
      key: 'discounts:9',
      url:
        'https://carolinas.discounts.aaa.com/deal/ShowCategory/43/0?cName=Online%20Mall&prevPage=All%20Deals',
      label: 'Online Mall',
    },
    {
      key: 'discounts:10',
      url: 'https://carolinas.discounts.aaa.com/deal/overview?id=Vacations',
      label: 'Vacations',
    },
    {
      key: 'discounts:11',
      url: 'https://carolinas.discounts.aaa.com/deal/overview?id=Local',
      label: 'Local',
    },
    {
      key: 'discounts:12',
      url:
        'https://carolinas.discounts.aaa.com/deal/overview?keyword=AAA%20TICKETS',
      label: 'AAA Tickets',
    },
    {
      key: 'discounts:13',
      url:
        'https://carolinas.discounts.aaa.com/deal/overview?prevPage=All%20Deals&searchType=18&gridName=Deals%20of%20the%20Week',
      label: 'Deals of the Week',
    },
    {
      key: 'discounts:14',
      url:
        'https://carolinas.discounts.aaa.com/deal/overview?prevPage=All%20Deals&searchType=11&gridName=Most%20Popular',
      label: 'Most Popular',
    },
    {
      key: 'discounts:15',
      url:
        'https://carolinas.discounts.aaa.com/deal/overview?prevPage=All%20Deals&searchType=19&gridName=Expiring%20Deals',
      label: 'Expiring Deals',
    },
    {
      key: 'discounts:16',
      url: 'https://aaaextension.com/api/aaa/browser',
      label: 'Browser Extension',
    },
  ],
];

export const navDiscountsPromo = [
  {
    title: 'AAA Discounts & Rewards',
    content: 'Members save an average of $160 a year by using AAA discounts.',
    img: '',
    buttonText: 'See all Discounts',
    buttonUrl:
      'https://carolinas.discounts.aaa.com/deal/overview?id=All%20Deals',
  },
];
